export const isFullRow = (type: string): boolean =>
    type == "map" || type == "bigText" || type === "richText"

export enum FeatureType {
    NewUI = 1,
    NewItemCollections = 2,
}
